import request from '@/utils/request';


// 获取分数
export function GetPage(params) {
  return request({
    url: '/api/user/integral/page',
    method: 'GET',
    params:params
  });
}
